export function shift(path: string, n: number): string {
    const regex = new RegExp(`(/[^/]+){${n}}`);
    return path.replace(regex, '');
}

export function removeTrailingSlash(path: string): string {
    if (!path) {
        return path;
    }

    path = path.trim();

    if (path.endsWith('/')) {
        return path.substring(0, path.indexOf('/'));
    }

    if (path.endsWith('%2F')) {
        return path.substring(0, path.indexOf('%2F'));
    }

    return path;
}